(function () {
  'use strict';

  angular
    .module('app.product.service', [])

    /* @ngInject */
    .factory('productService', function () {
      var products = {};
      return {
        setProduct: function (idGroup, product) {
          products = {};
          products[idGroup] = product;
        },
        setProductQuantity: function (idGroup, value) {
          products[idGroup].quantity = value;
        },
        setProductPrice: function (idGroup, price, costTTC, costHT, showTTCPrice, prices) {
          products[idGroup].Price = price;
          products[idGroup].costTTC = costTTC;
          products[idGroup].costHT = costHT;
          products[idGroup].showTTCPrice = showTTCPrice;
          products[idGroup].prices = prices;
        },
        setProductCustomization: function (idGroup, value) {
          products[idGroup].Customization = value;
          var customization = _.cloneDeep(value);
          _.each(customization.Items, function (item) {
            if (!item.Group) {
              item.Field.Comment = null;
            }
            if (item.Group) {
              _.each(item.Group.Fields, function (field) {
                field.Comment = null;
              });
            }
          });
          products[idGroup].Comment = md5(angular.toJson(customization));
        },
        setKitElement: function (idGroup, component) {
          if (component.Type && component.Type === 901 && component.Type === 903 && !component.Required && !component.Product) return;
          var product = products[idGroup];

          if (!product.elements) product.elements = {};
          if (!product.elements[component.uniqueId]) product.elements[component.uniqueId] = {};

          if (component.ProductPrices) {
            component.AdditionalCost = {
              TTCPrice: component.Product.SelectedProduct && component.ProductPrices[component.Product.SelectedProduct.IDProduct] ? component.ProductPrices[component.Product.SelectedProduct.IDProduct].TTCPrice : 0,
              HTPrice: component.Product.SelectedProduct && component.ProductPrices[component.Product.SelectedProduct.IDProduct] ? component.ProductPrices[component.Product.SelectedProduct.IDProduct].HTPrice : 0
            };
          }

          product.elements[component.uniqueId] = {
            idKitComponent: component.Id || 0,
            type: component.Type,
            idProduct: component.Product ? component.currentModel.IDProduct : 0,
            quantity: component.Quantity,
            isPrimary: component.isPrimary,
            allowAddToCart: component.currentModel ? component.currentModel.AllowAddToCart : false,
            required: component.Required || false,
            costTTC: component.AdditionalCost ? component.AdditionalCost.TTCPrice : 0,
            costHT: component.AdditionalCost ? component.AdditionalCost.HTPrice : 0
          };

          product.Elements = [];
          _.each(product.elements, function (element) {
            if (element.isPrimary && element.idProduct !== 0) {
              product.Elements.push({
                IDKitComponent: element.idKitComponent,
                IDProduct: element.idProduct,
                Quantity: element.quantity
              });
            }
          });
          product.Comment = md5(angular.toJson(product.Elements));
        },
        getProduct: function () {
          return products;
        },
        getProductsData: function () {
          var data = [];
          _.each(products, function (product) {
            data.push(product);
          });
          return data;
        },
        getProductCustomisation: function (idGroup) {
          return (products[idGroup] && products[idGroup].Customization) ? products[idGroup].Customization : null;
        },
        getActive: function () {
          var result = true;
          _.each(products, function (product) {
            if (!product.isPrimary) {
              result = false;
              return false;
            }
            _.each(product.elements, function (component) {
              if (!component.type) {
                if (!component.allowAddToCart) {
                  result = false;
                  return false;
                }
              } else if (component.type === 901 || component.type === 903) {
                if (component.required && !component.allowAddToCart) {
                  result = false;
                  return false;
                }
              } else if (component.type === 902) {
                if (component.required && !component.allowAddToCart) {
                  result = false;
                  return false;
                }
              }
            });
          });
          return result;
        }
      };
    });

})();
